import React, { useState, useEffect } from "react";
import {
  Modal,
  Box,
  Typography,
  Button,
  Grid,
  Card,
  CardContent,
} from "@mui/material";

const BoxDetailsModal = ({
  boxDetailsJson,
  handleCloseBoxDetails,
  boxDetailsView,
}: any) => {
  const [boxDetails, setBoxDetails] = useState<any>(null);

  // Parse the JSON string and set the state
  useEffect(() => {
    if (boxDetailsJson) {
      setBoxDetails(JSON.parse(boxDetailsJson));
    }
  }, [boxDetailsJson]);

  // Calculate total number of boxes
  const calculateTotalBoxes = () => {
    if (boxDetails) {
      return (
        boxDetails.smallBoxes +
        boxDetails.mediumBoxes +
        boxDetails.largeBoxes +
        boxDetails.dishPacks +
        boxDetails.mirrorCartons +
        boxDetails.wardrobeBoxes
      );
    }
    return 0;
  };

  return (
    <Modal open={boxDetailsView} onClose={handleCloseBoxDetails}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 500,
          backgroundColor: "white",
          padding: 4,
          borderRadius: 2,
          boxShadow: 24,
        }}
      >
        <Typography variant="h5" gutterBottom align="center" color="primary">
          Box Details
        </Typography>

        <Card sx={{ marginBottom: 3 }}>
          <CardContent>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <Typography variant="body1">
                  <strong>Small Boxes:</strong> {boxDetails?.smallBoxes}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="body1">
                  <strong>Medium Boxes:</strong> {boxDetails?.mediumBoxes}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="body1">
                  <strong>Large Boxes:</strong> {boxDetails?.largeBoxes}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="body1">
                  <strong>Dish Packs:</strong> {boxDetails?.dishPacks}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="body1">
                  <strong>Mirror Cartons:</strong> {boxDetails?.mirrorCartons}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="body1">
                  <strong>Wardrobe Boxes:</strong> {boxDetails?.wardrobeBoxes}
                </Typography>
              </Grid>
            </Grid>
          </CardContent>
        </Card>

        <Typography variant="h6" gutterBottom>
          <strong>Total Boxes:</strong> {calculateTotalBoxes()}
        </Typography>

        <Box display="flex" justifyContent="center">
          <Button
            variant="contained"
            color="primary"
            onClick={handleCloseBoxDetails}
          >
            Close
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default BoxDetailsModal;
